fragment EditionBasicFragment on Edition {
    id
    id
    isABTesting
}
